import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../core/api/queries";

export interface PatientUtilizationQuery {
  from?: string;
  to?: string;
  officeIds?: number[];
  contractTypeIds?: number[];
  coordinatorIds?: number[];
  periodTypes?: string[];
  patientStatuses?: string[];
  noScheduleYet?: boolean;
  states?: string[];
  search?: string;
  limit?: number;
  offset?: number;
}

export interface DashboardQuery {
  from?: string;
  to?: string;
  officeIds?: number[];
  contractTypeIds?: number[];
  coordinatorIds?: number[];
  periodTypes?: string[];
  patientStatuses?: string[];
  states?: string[];
}

export default createQueryGroup(({ api }) => ({
  patients: (query: PatientUtilizationQuery) => {
    return queryOptions({
      queryKey: ["authorization_utilization", "patients", query],
      queryFn: () => (api as any).get("./authorization_utilization_reports/patients", { query }),
      placeholderData: keepPreviousData,
    });
  },
  dashboard: (query: DashboardQuery) => {
    return queryOptions({
      queryKey: ["authorization_utilization", "dashboard", query],
      queryFn: () => (api as any).get("./authorization_utilization_reports/dashboard", { query }),
      placeholderData: keepPreviousData,
    });
  },
}));
